import React from 'react'
import Hero from './components/Hero'
import Problem from './components/Problem'
import Comparison from './components/Comparison'
import Benefits from './components/Benefits'
import HowItWorks from './components/HowItWorks'
import Pricing from './components/Pricing'
import Guarantee from './components/Guarantee'
import ForWho from './components/ForWho'
import SocialProof from './components/SocialProof'
import FinalCTA from './components/FinalCTA'
import FAQ from './components/FAQ'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Hero />
      <Problem />
      <Comparison />
      <Benefits />
      <HowItWorks />
      <Pricing />
      <Guarantee />
      <ForWho />
      <SocialProof />
      <FinalCTA />
      <FAQ />
      <Footer />
    </div>
  )
}

export default App
